import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

const WaitIcon = React.memo(
  ({ className }: Props) => (
    <svg data-testid="wait-icon" className={className} width="60" height="60">
      <g fill="none">
        <path d="M0 0h60v60H0z" />
        <path stroke="#84B8FF" d="M50.3 24.5A21 21 0 1136 10" />
        <path
          fill="#D7E3FF"
          d="M45.6 24.6a16.5 16.5 0 11-10.8-10.4L30 30l15.6-5.4z"
        />
        <path fill="#B5D0FF" d="M32.5 30a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0" />
        <path
          stroke="#84B8FF"
          d="M32.5 30a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm.5-10l-2 7m12-2l-10 4"
        />
        <path stroke="#FFF" d="M16.5 31c0-6.9 4.8-12.7 11.3-14.1" />
      </g>
    </svg>
  ),
  arePropsEqual
);

export default React.memo(WaitIcon);
